/**
 * Copyright(c) 2024 Valoriz Digital Pvt. Ltd.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Valoriz ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Valoriz.
 *
 * @author Valoriz UI Team
 */

import React, { FC } from "react";
import { IconProps } from "@/common/lib/types";

const Icon: FC<IconProps> = (props) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="12" height="12" viewBox="0 0 12 12">
      <defs>
        <clipPath id="clip-calendar">
          <rect width="12" height="12" />
        </clipPath>
      </defs>
      <g id="calendar" clipPath="url(#clip-calendar)">
        <g id="Icon_akar-calendar" data-name="Icon akar-calendar">
          <path
            id="Path_82"
            data-name="Path 82"
            d="M3,2H9a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H3A2,2,0,0,1,1,9V4A2,2,0,0,1,3,2Z"
            fill="none"
            stroke="#000"
            className="stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_83"
            data-name="Path 83"
            d="M4,1V3M8,1V3M1,5H11"
            fill="none"
            stroke="#000"
            className="stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
